import React from "react";

export default function FunnelChart({ stages = [], showDropoff = true, showDays = true }) {
  if (!stages.length) return null;
  const maxCount = stages[0]?.count || 1;

  return (
    <div className="space-y-1">
      {stages.map((s, i) => (
        <div key={s.name}>
          <div className="flex items-center gap-2">
            <span className="text-xs text-vf-muted w-20 text-right flex-shrink-0">{s.name}</span>
            <div className="flex-1 bg-slate-100 rounded-full h-6 relative overflow-hidden">
              <div
                className="h-full rounded-full flex items-center px-2"
                style={{ width: `${Math.max((s.count / maxCount) * 100, 5)}%`, background: `hsl(${240 - i * 20}, 70%, 60%)` }}
              >
                <span className="text-[10px] text-white font-medium whitespace-nowrap">{s.count}</span>
              </div>
            </div>
            <span className="text-xs text-vf-muted w-12 flex-shrink-0">{s.pct}%</span>
            {showDays && <span className="text-[10px] text-vf-muted w-12 flex-shrink-0">{s.avgDaysInStage}d</span>}
          </div>
          {showDropoff && i < stages.length - 1 && s.dropoff > 0 && (
            <div className="ml-24 text-[10px] text-red-500 my-0.5">↓ {s.dropoff}% dropoff</div>
          )}
        </div>
      ))}
    </div>
  );
}
